<template>
    <BlocksStationsLunch :lunch="cards" />
</template>
<script>
export default {
    name: 'CardListLunchMenu',
    props: {
        contentType: {
            type: String,
            required: false,
            default: 'cardList',
        },
        internal: {
            type: String,
            required: false,
            default: '',
        },
        display: {
            type: Object,
            required: false,
            default: () => ({
                component: 'lunch',
            }),
        },
        title: {
            type: String,
             required: false,
             default: '',
        },
        cards: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
};
</script>
